import { Button, Card } from "@material-ui/core";
import React, { useEffect } from "react";
import { useState } from "react";
import firebase_ from "../../../../firebase/firebase";

function CreateTask() {
  const [task, setTask] = useState({
    currentTask: {
      description: "",
      date: "",
      project: "",
    },
  });
  const db = firebase_.firestore();
  const [projectList, setProjectList] = useState([]);
  const [taskList, setTaskList] = useState([]);

  async function fetchTaskList() {
    setTaskList([]);
    await db
      .collection("task")
      .where("userEmail", "==", sessionStorage.getItem("emailId"))
      .get()
      .then((res) => {
        res.forEach((item) => {
          setTaskList((taskList) => [...taskList, item.data()]);
        });
      })
      .catch((err) => {
        console.log("Project error ", err);
      });
  }
  async function fetchProjects() {
    await db
      .collection("project")
      .get()
      .then((res) => {
        res.forEach((item) => {
          setProjectList((projectList) => [...projectList, item.data()]);
        });
      })
      .catch((err) => {
        console.log("Project error ", err);
      });
  }

  useEffect(() => {
    fetchProjects();
    fetchTaskList();
  }, []);

  const handleSubmit = (e) => {
    e.preventDefault();
    console.log("task : ", task);
    db.collection("task")
      .add({
        userEmail: sessionStorage.getItem("emailId"),
        taskDescription: task.currentTask.description,
        taskDate: task.currentTask.date,
        project: task.currentTask.project,
      })
      .then((res) => {
        console.log("Added successfully", res);
        fetchTaskList();
        setTask({
          currentTask: {
            description: "",
            date: "",
            project: "",
          },
        });
      })
      .catch((err) => {
        console.log("Error handle", err);
      });
  };
  const handleChange = (e) => {
    setTask({
      currentTask: {
        ...task.currentTask,
        [e.target.name]: e.target.value,
      },
    });
  };
  return (
    <div>
      <div>
        <form onSubmit={handleSubmit}>
          <input
            className="add-question-inpt"
            onChange={handleChange}
            placeholder="Task Description"
            required
            name="description"
            type="textarea"
            value={task.currentTask.description}
          />
          <input
            className="add-question-inpt"
            onChange={handleChange}
            placeholder="Date"
            required
            type="date"
            name="date"
            value={task.currentTask.date}
          />
          <input
            className="add-question-inpt"
            onChange={handleChange}
            placeholder="Project"
            required
            name="project"
            value={task.currentTask.project}
          />
          <Button className="add-question-btn" type="submit">
            Add
          </Button>
        </form>
      </div>
      <div className="task-list">
        {taskList.map((data, index) => {
          return (
            <Card className="users-card">
              <p>{data["taskDescription"]}</p>
              <p>{data["project"]}</p>
              <p>{data["taskDate"]}</p>
            </Card>
          );
        })}
      </div>
    </div>
  );
}

export default CreateTask;
